"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactName = require("./ContactName");
Object.keys(_ContactName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactName[key];
    }
  });
});